/**
 * Colour swatch dot (Phase 65 / BLU-594 PR2). Decorative only — always sits
 * beside the colour NAME (never colour as the sole signal, DESIGN §16). Unknown
 * names fall back to a neutral ring so a missing hex never reads as black.
 */
import { cn } from '@/lib/utils';
import { colourSwatchHex } from '../lib/colour-swatch';

interface ColourDotProps {
  name: string | null | undefined;
  className?: string;
}

export function ColourDot({ name, className }: ColourDotProps) {
  const hex = colourSwatchHex(name);
  return (
    <span
      aria-hidden
      className={cn(
        'inline-block h-3 w-3 shrink-0 rounded-full border',
        hex ? 'border-black/15' : 'border-dashed border-muted-foreground/40 bg-muted',
        className,
      )}
      style={hex ? { backgroundColor: hex } : undefined}
    />
  );
}
